// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__2ySmB","icon":"IconButton_icon__37rXb"};